var generic = generic || {};
var csrfTokenVal;

csrfTokenVal = csrfTokenVal || {};

(function ($, Drupal) {
  'use strict';

  var customPaletteV1 = {
    formatter: $('.custom-palette-v1'),
    COLLECTION_NAME: false
  };

  Drupal.behaviors.customPaletteV1 = {
    args: {
      SKU_BASE_ID: []
    },
    cartParams: {
      checkout: {
        add: {
          _SUBMIT: 'alter_collection',
          action: 'add,edit,create_kit'
        },
        edit: {
          _SUBMIT: 'cart',
          action: 'clear_kit,add,sync',
          actionKey: 'cmode',
          id_key: 'CART_ID'
        }
      }
    },

    get: function (key) {
      return customPaletteV1[key];
    },

    set: function (key, val) {
      customPaletteV1[key] = val;
    },

    configPans: function (thisFormatter) {
      // setup number of zones based on pan type
      var panType = thisFormatter.data('pan-type');
      var numberOfZones = [];

      switch (panType) {
        case 'MAC_2_PALETTE':
        case 'MAC_2_PALETTE_2':
        case 'MAC_2_CREME_PALETTE':
        case 'MAC_2_BLUSH_PALETTE':
          numberOfZones = [2];
          break;
        case 'MAC_1x1_PALETTE':
          numberOfZones = [1, 1];
          break;
        case 'MAC_4_PALETTE':
        case 'MAC_4_PALETTE_2':
          numberOfZones = [4];
          break;
        case 'MAC_2x2_PALETTE':
          numberOfZones = [2, 2];
          break;
        case 'MAC_6_PALETTE':
        case 'MAC_6_BLUSH_PALETTE_2':
        case 'MAC_6_BLUSH_PALETTE':
        case 'MAC_6_PRO_LONGWEAR_PALETTE':
          numberOfZones = [6];
          break;
        case 'MAC_2x4_PALETTE':
          numberOfZones = [2, 4];
          break;
        case 'MAC_12_PALETTE':
          numberOfZones = [12];
          break;
        case 'MAC_2x6_PALETTE':
          numberOfZones = [2, 6];
          break;
        case 'MAC_9_PALETTE':
          numberOfZones = [9];
          break;
        case 'MAC_15_PALETTE':
          numberOfZones = [15];
          break;
        case 'MAC_2x9_BLUSH_PALETTE':
        case 'MAC_2x9_CREME_PALETTE':
          numberOfZones = [2, 9];
          break;
        case 'MAC_4x2_PALETTE':
          numberOfZones = [4, 2];
          break;
        case 'MAC_2x12_PALETTE':
          numberOfZones = [2, 12];
          break;
        case 'MAC_2x2x6_PALETTE':
          numberOfZones = [2, 2, 6];
          break;
        case 'MAC_15x4x2_PALETTE':
          numberOfZones = [15, 4, 2];
          break;
        case 'MAC_30_PALETTE':
          numberOfZones = [30];
          break;
        default:
          break;
      }

      var $inserts = $('<div class="product__detail-inserts"></div>');

      for (var i = 0; i < numberOfZones.length; i++) {
        var active = i === 0 ? ' active' : '';
        var $insert = $(
          '<div class="product__detail-insert product__detail-insert-' +
            (i + 1) +
            active +
            '" data-insert="' +
            (i + 1) +
            '"></div>'
        );
        var $zonesHolder = $('<div class="product__detail-zones"></div>');
        var $zoneWrapper = $('<div class="product__detail-zone"></div>');

        if (!thisFormatter.hasClass('is-mobile')) {
          $insert.append('<div class="product__detail-insert__overlay"></div>');
        }
        $insert.append($zonesHolder);
        for (var j = 0; j < numberOfZones[i]; j++) {
          $zonesHolder.append(
            $zoneWrapper.clone(true).attr('data-test-id', 'spp_custom_palette_layout_' + panType + '_' + (j + 1))
          );
          if (panType === 'MAC_30_PALETTE' && j === 14) {
            $zonesHolder.append('<div class="product__detail-zone-spacer"></div>');
          }
        }
        $inserts.append($insert);
      }
      thisFormatter.find('.product__detail').append($inserts);

      if (thisFormatter.hasClass('is-mobile')) {
        var $shadeList = thisFormatter.find('.product__shade_list');

        for (var mi = 0; mi < numberOfZones.length; mi++) {
          var mactive = mi === 0 ? ' active' : '';
          var $minsert = $(
            '<div class="product__shade_list-insert product__shade_list-insert-' +
              (mi + 1) +
              mactive +
              '" data-insert="' +
              (mi + 1) +
              '"></div>'
          );

          $shadeList.append($minsert);
        }
      }

      return numberOfZones;
    },

    setShadesHeight: function (thisFormatter) {
      var shades = thisFormatter.find('.shade-picker__colors');
      var windowHeight = $(window).height();
      var headerHeight =
        $('.site-header').height() > 0 ? $('.site-header').height() : $('.site-header__wrapper').height();
      var secNavHeight = $('.sec-nav').height();
      var shadePickerHeadingHeight = $('.shade-picker__tools-heading').outerHeight(false);
      var controlsHeight = $('.shade-picker__controls').height();
      var siteBannerHeight = $('.site-banner').height();
      var productAddToBagHeight = $('.js-product__add-to-bag').height();
      var containerHeight;

      if (thisFormatter.hasClass('is-mobile')) {
        containerHeight = windowHeight - headerHeight - shadePickerHeadingHeight - productAddToBagHeight + 1;
        shades.css('max-height', containerHeight + 'px');
        shades.height(containerHeight);
        shades.css('overflow', 'auto');
      } else {
        containerHeight = windowHeight - headerHeight - secNavHeight - controlsHeight - controlsHeight;
        shades.css(
          'max-height',
          thisFormatter.find('.product__wrapper').outerHeight(false) - controlsHeight - controlsHeight
        );
        shades.attr('data-max-height', parseInt(shades.css('max-height')));
        containerHeight = containerHeight + siteBannerHeight;
        shades.height(containerHeight + 'px');
        shades.attr('data-height', shades.height());
      }
    },

    initScrollButtons: function (thisFormatter) {
      var $resultsMask = thisFormatter.find('.shade-picker__wrapper');
      var shades = $resultsMask.find('.shade-picker__colors');
      var scrollAmount = $resultsMask.find('.shade-picker__color').height() * 3;

      $('.shade-picker__next', $resultsMask)
        .once()
        .click(function () {
          shades.scrollTo('+=' + scrollAmount + 'px', 500);
        });
      $('.shade-picker__previous', $resultsMask)
        .once()
        .click(function () {
          shades.scrollTo('-=' + scrollAmount + 'px', 500);
        });
    },

    buildShadeTooltip: function (shadeObject) {
      // tooltip with shade name/desc on palette hover
      var shadeColor = shadeObject.find('.shade-picker__color-chip').css('background-color');
      var shadeTooltip = shadeObject.find('.shade-picker__color-tooltip');
      var shadeName = shadeObject.find('.shade-picker__color-details');

      shadeTooltip.css('background-color', shadeColor);

      shadeObject.hover(
        function () {
          shadeTooltip.removeClass('hidden');
          shadeName.addClass('hidden');
        },
        function () {
          shadeTooltip.addClass('hidden');
          shadeName.removeClass('hidden');
        }
      );

      // detect hex color brightness to toggle black/white text
      // http://www.w3.org/TR/AERT#color-contrast
      var rgb = shadeColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      var brightness = Math.round((parseInt(rgb[1]) * 299 + parseInt(rgb[2]) * 587 + parseInt(rgb[3]) * 114) / 1000);

      if (brightness > 200) {
        shadeTooltip.addClass('shade-light');
      } else {
        shadeTooltip.addClass('shade-dark');
      }
    },

    initTitleEditing: function (thisFormatter) {
      // inline editing of palette title via edit link
      var self = this;
      var editTitle = thisFormatter.find('.product__name-editable');
      var $defaultTitle = editTitle.find('.default-title');
      var $editLink = editTitle.find('.edit-link');
      var $closeLink = editTitle.find('.close-link');
      var field = editTitle.find('.product__name-field');
      var updateTitle = function () {
        var value = field.val();

        if (value !== $defaultTitle) {
          $defaultTitle.html(value);
          self.set('COLLECTION_NAME', value);
        }
      };

      $editLink
        .removeClass('hidden')
        .once()
        .click(function () {
          editTitle.addClass('editing');
          $closeLink.removeClass('hidden');
          var tmpVal = field.val();

          field
            .focus()
            .val('')
            .val(tmpVal)
            .on('blur keypress', function (e) {
              if (e.type === 'blur' || e.which === 13) {
                updateTitle();
                editTitle.removeClass('editing');
              }
            });

          return false;
        });

      $closeLink.once().click(function () {
        editTitle.removeClass('editing');
        $closeLink.addClass('hidden');
        updateTitle();

        return false;
      });
    },

    setCustomPaletteArgs: function (thisFormatter) {
      var self = this;

      self.args.collection_name = thisFormatter.find('.product__name-field').val();
      self.args.SKU_BASE_ID = [];
      var shades = thisFormatter.find('.product__detail-zones .shade-picker__color');

      shades.each(function () {
        self.args.SKU_BASE_ID.push(parseInt($(this).data('product').SKU_BASE_ID));
      });
      self.args.cat_base_id = '791';
      self.args.collection_subtype = thisFormatter.data('pan-type');

      return self.args;
    },

    getCustomPaletteArgs: function (thisFormatter) {
      // populate the title and shades in the palette based on args from url
      var self = this;

      function getSearchParameters() {
        var prmstr = window.location.search.substr(1);

        return prmstr !== null && prmstr !== '' ? transformToAssocArray(prmstr) : {};
      }

      function transformToAssocArray(prmstr) {
        var params = {};
        var prmarr = prmstr.split('&');

        for (var i = 0; i < prmarr.length; i++) {
          var tmparr = prmarr[i].split('=');

          params[tmparr[0]] = tmparr[1];
        }

        return params;
      }

      var params = getSearchParameters();

      if (params.COLLECTION_ID) {
        self.args.COLLECTION_ID = params.COLLECTION_ID;
      }

      if (params.CART_ID) {
        self.args.CART_ID = params.CART_ID;
      } else {
        self.initTitleEditing(thisFormatter);
      }

      // populate the pan
      if (params.SKU_BASE_ID) {
        var skus = params.SKU_BASE_ID.trim().split(',');

        for (var a in skus) {
          if (skus.hasOwnProperty(a)) {
            skus[a] = parseInt(skus[a], 10);
          }
        }

        var $colorInserts = thisFormatter.find('.shade-picker__colors-insert');
        var zones = thisFormatter.find('.product__detail-zones .product__detail-zone');

        /* jshint -W083 */
        for (var i = 0; i < skus.length; i++) {
          $colorInserts.each(function () {
            var insert = $(this).data('insert');
            var $shadeListInsert = $('.product__shade_list-insert[data-insert="' + insert + '"]');
            var shades = $(this).find('.shade-picker__color');

            shades.each(function () {
              var skuBaseId = parseInt($(this).data('product').SKU_BASE_ID);

              if (skus[i] === skuBaseId) {
                var shadeClone = $(this).clone();

                zones.eq(i).append(shadeClone);

                if (thisFormatter.hasClass('is-mobile')) {
                  var $shadeList = thisFormatter.find('.product__shade_list');

                  shadeClone.clone().appendTo($shadeListInsert);
                } else {
                  shadeClone.draggable({
                    revert: 'invalid',
                    cursor: 'pointer',
                    cursorAt: {
                      top: 15,
                      left: 15
                    },
                    scope: 'custom_palette_' + insert,
                    appendTo: '.page--spp__custom_palette',
                    containment: 'window',
                    zIndex: 99999,
                    helper: function () {
                      return $(this).clone().addClass('ui-draggable-active');
                    },
                    start: function (event, ui) {
                      $(this).addClass('ui-draggable-blur');
                    },
                    stop: function (event, ui) {
                      $(this).removeClass('ui-draggable-blur');
                    }
                  });

                  self.buildShadeTooltip(shadeClone);
                }
              }
            });
          });
        }
        $(window).on('load', function () {
          self.enableButtons(thisFormatter);
        });
      }

      // set custom title
      const title_field_val = thisFormatter.find('.product__name-field');
      const title_field_txt = thisFormatter.find('.product__name .default-title');

      if (params.collection_name) {
        const title = decodeURIComponent(params.collection_name);

        if (title !== 'undefined') {
          title_field_val.val(title);
          title_field_txt.text(title);
        }
      } else {
        // Store the default title to use
        const defaultTitle = title_field_txt.text();

        title_field_txt.data('defaultTitle', defaultTitle);

        this.randomizeCollectionTitle();
      }
    },
    randomizeCollectionTitle: function () {
      /** 
       * Because of how collections work, you need a unique collection name
       * Randomizing is not ideal, but that's how this was built
       * This code will randomize the collection name on initial load, and after each Add to Bag
      */

      const formatter = this.get('formatter');
      const title_field_val = formatter.find('.product__name-field');
      const title_field_txt = formatter.find('.product__name .default-title');
      const defaultTitle = title_field_txt.data('defaultTitle');

      if (defaultTitle !== 'undefined') {
        const randomNum = Math.floor(Math.random() * 10000);

        title_field_val.val(defaultTitle + ' #' + randomNum);
        title_field_txt.text(defaultTitle + ' #' + randomNum);
      }
    },
    enableButtons: function (thisFormatter) {
      thisFormatter.find('.product__add-to-bag').removeAttr('disabled').removeClass('btn--disabled');
    },

    addToBag: function (args) {
      var self = this;
      var cartType = 'checkout';
      var mode = args.CART_ID || args.COLLECTION_ID ? 'edit' : 'add';
      // default params
      var params = {
        COLLECTION_TYPE: 'UKIT',
        CAT_BASE_ID: args.cat_base_id,
        COLLECTION_SUBTYPE: args.collection_subtype,
        COLLECTION_NAME: args.collection_name,
        SKU_BASE_ID: args.SKU_BASE_ID,
        INCREMENT: '0',
        QTY: '1'
      };

      // get params for cart type (checkout or favorites) & action mode (add or edit)
      var postParams = self.cartParams[cartType];
      var actionKey = postParams[mode].actionKey ? postParams[mode].actionKey : 'action';

      params[actionKey] = postParams[mode].action;
      params._SUBMIT = postParams[mode]._SUBMIT;
      params.HAS_MULTIPLE_SKUS = 1;

      if (mode === 'edit') {
        var idKey = postParams[mode].id_key;
        var lcIdKey = idKey.toLowerCase();

        params[idKey] = args[lcIdKey];
        params.CART_ID = args.CART_ID;
        params.COLLECTION_ID = args.COLLECTION_ID;
      }

      generic.jsonrpc.fetch({
        method: 'cart',
        params: [params],
        onSuccess: function (jsonRpcResponse) {
          var data = jsonRpcResponse.getData();

          $(window).trigger('addToCart.success', [data]);
        },
        onFailure: function (ss) {
          /**
           * Handle error messaging
           * copied from /sites/maccosmetics/libraries/product-ui/core.js
           * The getMessages() sometimes return offer success messages instead of cart limit error
           * Since getMessages() in jsonrpc.js gives precendence to messages over errors
           * So, getError() is rendered and getMessages() is set as fallback
           */
          const errorObject = ss.getError();
          const errorObjectsArray = errorObject?.data?.messages || ss.getMessages();

          $(document).trigger('addToCart.failure', [errorObjectsArray]);
          const $errorMessageContainer = $('<div/>', {
            html: '<span class="cboxLoadedContent-error" data-test-id="max_error_message">' + errorObjectsArray[0].text + '</span>'
          });

          generic.overlay.launch({
            content: $errorMessageContainer,
            includeBackground: true,
            includeCloseLink: true,
            initialHeight: 0,
            height: 0,
            width: '50%',
            onComplete: function () {
              $(this).colorbox.resize();
            }
          });
        }
      });

      // Randomize the name
      self.randomizeCollectionTitle();
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var totalZones = _.reduce(
          self.configPans(thisFormatter),
          function (a, b) {
            return a + b;
          },
          0
        );
        var $inserts = thisFormatter.find('.product__detail-insert');
        var shadePickerHeadings = thisFormatter.find('.shade-picker__tools-heading');
        var shadePickerInserts = thisFormatter.find('.shade-picker__colors-insert');
        var $shadePickerTools = thisFormatter.find('.shade-picker__tools');
        var filter_insert = $shadePickerTools.data('insert');
        var counter = 0;

        thisFormatter.find('.product__add-to-bag').click(function () {
          if ($(this).hasClass('btn--disabled')) {
            return false;
          } else {
            self.args = self.setCustomPaletteArgs(thisFormatter);
            self.addToBag(self.args);
          }
        });

        if (thisFormatter.hasClass('is-mobile')) {
          // mobile functionality
          var $shadeList = thisFormatter.find('.product__shade_list');
          var $animate = thisFormatter.find('.shade-picker__wrapper');
          var $zones = thisFormatter.find('.product__detail-zone');
          var $thisZone;
          var navdirection = site.direction.isRTL ? 'right' : 'left';
          var animateInArg = navdirection === 'right' ? { right: '11.5%' } : { left: '11.5%' };
          var animateOutArg = navdirection === 'right' ? { right: '100%' } : { left: '100%' };

          $zones.each(function () {
            $(this)
              .once()
              .click(function () {
                if (!thisFormatter.hasClass('shade-picker-open')) {
                  $thisZone = $(this);
                  var insert = $thisZone.parents('.product__detail-insert').data('insert');

                  // swap shade picker heading
                  shadePickerHeadings.addClass('hidden');
                  $('.shade-picker__tools-heading[data-insert="' + insert + '"]').removeClass('hidden');

                  // swap shade picker colors
                  shadePickerInserts.addClass('hidden');
                  $('.shade-picker__colors-insert[data-insert="' + insert + '"]').removeClass('hidden');

                  self.setShadesHeight(thisFormatter);
                  $('html, body').addClass('noscroll fixedpos');
                  thisFormatter.addClass('shade-picker-open');

                  $animate
                    .find('.shade-picker__colors')
                    .scrollTo(0, 150, function () {
                      $animate.animate(animateInArg, 300, function () {
                        $animate.focus();
                        $animate.on('clickoutside', function () {
                          thisFormatter.removeClass('shade-picker-open');
                          $('html, body').removeClass('noscroll fixedpos');
                          $animate.animate(animateOutArg, 300, function () {
                            $animate.unbind('clickoutside');
                          });
                        });
                      });
                    })
                    .focus();
                }
              });
          });

          thisFormatter
            .find('.shade-picker__color')
            .once()
            .click(function () {
              if (thisFormatter.hasClass('shade-picker-open')) {
                var $thisShade = $(this).clone();
                var $activeShadeList = $shadeList.find('.product__shade_list-insert.active');

                if ($thisZone.is(':empty')) {
                  counter++;
                } else {
                  var oldShade = $thisZone.find('.shade-picker__color');
                  var oldSku = oldShade.data('product').sku;

                  $activeShadeList.find('.shade-picker__color').each(function () {
                    var thisSku = $(this).data('product').sku;

                    if (oldSku === thisSku) {
                      $(this).remove();

                      return false;
                    }
                  });
                  $thisZone.empty();
                }

                $thisShade.prependTo($thisZone);
                $thisShade.clone().appendTo($activeShadeList);

                $animate.animate(animateOutArg, 300, function () {
                  // when palette is full
                  if (counter == totalZones) {
                    self.enableButtons(thisFormatter);
                  }
                  $animate.unbind('clickoutside');
                });

                thisFormatter.removeClass('shade-picker-open');
                $('html, body').removeClass('noscroll fixedpos');
              }
            });
        } else {
          // desktop functionality
          thisFormatter
            .find('.js-artist-palette-add-to-bag')
            .once()
            .click(function () {
              self.args = self.setCustomPaletteArgs(thisFormatter);
              var data = $(this).data('product');

              self.args.SKU_BASE_ID = data.SKU_BASE_ID;
              self.args.collection_name = data.collection_name;
              self.addToBag(self.args);

              return false;
            });

          $(window).on('sidewideBanner:down:animationComplete sidewideBanner:disabled', function () {
            var shadePickerWrapper = thisFormatter.find('.shade-picker__wrapper');
            var shadePickerColors = thisFormatter.find('.shade-picker__colors');
            var $secNavStickyBanner = $('.sec-nav.site-banner__sticky-fix', context);
            var $fixedHeader = $('.js-site-header-fixed-wrapper, .js-site-header-formatter-inner', context);
            var pickerBannerTopPosition = $fixedHeader.length > 0 ? $fixedHeader.height() + 'px' : '82px';
            var pickerBannerBottomPosition = $('.site-footer--sticky', context).length > 0 ? '7.2%' : '0';
            var initPickerTop = function () {
              shadePickerWrapper.css({
                top: pickerBannerTopPosition,
                bottom: pickerBannerBottomPosition
              });
              $secNavStickyBanner.css('top', pickerBannerTopPosition);
              shadePickerColors.height(shadePickerColors.attr('data-height') + 'px');
              self.setShadesHeight(thisFormatter);
            };

            initPickerTop();
            shadePickerWrapper.show();
            // init scroll buttons
            self.initScrollButtons(thisFormatter);

            $('.site-footer').waypoint({
              handler: function (direction) {
                shadePickerWrapper.toggleClass('at-bottom', direction === 'down');
                shadePickerWrapper.css('top', '-120px');
                if (direction === 'up') {
                  initPickerTop();
                } else {
                  shadePickerColors.height(shadePickerColors.attr('data-max-height') + 'px');
                }
              },
              offset: '100%'
            });
          });

          // shade column tooltip
          $('body').addClass('tooltipster-body-overflow-fix');
          thisFormatter.find('.shade-picker__colors-item').tooltipster({
            arrow: false,
            contentAsHTML: true,
            hideOnClick: true,
            theme: 'mac-tooltip',
            offsetX: 10
          });

          $inserts.each(function () {
            var $thisInsert = $(this);
            var insert = $thisInsert.data('insert');

            // shade column draggable
            $('.shade-picker__colors-insert[data-insert="' + insert + '"]')
              .find('.shade-picker__color')
              .draggable({
                revert: 'invalid',
                cursor: 'pointer',
                cursorAt: {
                  top: 15,
                  left: 15
                },
                scope: 'custom_palette_' + insert,
                appendTo: '.page--spp__custom_palette',
                containment: 'window',
                zIndex: 99999,
                helper: function () {
                  return $(this).clone().addClass('ui-draggable-active');
                },
                start: function (event, ui) {
                  $(this).addClass('ui-draggable-blur');
                },
                stop: function (event, ui) {
                  $(this).removeClass('ui-draggable-blur');
                }
              });

            // palette droppable region
            $thisInsert.find('.product__detail-zone').droppable({
              accept: '.shade-picker__color',
              scope: 'custom_palette_' + insert,
              tolerance: 'pointer',
              hoverClass: 'ui-droppable-hover',
              activeClass: 'ui-droppable-active',
              drop: function (event, ui) {
                var $this = $(this);
                var $that = ui.draggable.clone();
                var $thatParent = ui.draggable.parent('.ui-droppable');

                if ($this.is(':empty')) {
                  if ($thatParent.length === 1) {
                    $thatParent.empty();
                  } else {
                    counter++;
                  }
                  $that.prependTo($this);
                } else {
                  // swap items
                  if ($thatParent.length === 1) {
                    var $thisChild = $this.find('.ui-draggable').clone();

                    $thatParent.empty();
                    $thisChild.prependTo($thatParent);
                    $thisChild.draggable({
                      revert: 'invalid',
                      cursor: 'pointer',
                      cursorAt: {
                        top: 15,
                        left: 15
                      },
                      scope: 'custom_palette_' + insert,
                      appendTo: '.page--spp__custom_palette',
                      containment: 'window',
                      zIndex: 99999,
                      helper: function () {
                        return $(this).clone().addClass('ui-draggable-active');
                      },
                      start: function (event, ui) {
                        $(this).addClass('ui-draggable-blur');
                      },
                      stop: function (event, ui) {
                        $(this).removeClass('ui-draggable-blur');
                      }
                    });
                    self.buildShadeTooltip($thisChild);
                  }
                  $this.empty();
                  $that.prependTo($this);
                }

                // when palette is full
                if (counter == totalZones) {
                  self.enableButtons(thisFormatter);
                }

                $that.draggable({
                  revert: 'invalid',
                  cursor: 'pointer',
                  cursorAt: {
                    top: 15,
                    left: 15
                  },
                  scope: 'custom_palette_' + insert,
                  appendTo: '.page--spp__custom_palette',
                  containment: 'window',
                  zIndex: 99999,
                  helper: function () {
                    return $(this).clone().addClass('ui-draggable-active');
                  },
                  start: function (event, ui) {
                    $(this).addClass('ui-draggable-blur');
                  },
                  stop: function (event, ui) {
                    $(this).removeClass('ui-draggable-blur');
                  }
                });

                self.buildShadeTooltip($that);

                $('body').css('cursor', 'auto');
              }
            });
          });

          // show artist overlay on click of "Inspire Me" link
          thisFormatter
            .find('.toggle-artist-overlay')
            .once()
            .click(function () {
              var overlay = thisFormatter.find('.page--spp__custom_palette-overlay');
              var carousel = overlay.find('.slick-initialized');

              overlay.removeClass('hidden');
              carousel.slickSetOption('useCSS', true, true);
              overlay
                .find('.custom-palette__artist-formatter-close')
                .once()
                .click(function () {
                  overlay.addClass('hidden');
                });
            });

          // show/hide shade names link toggle
          thisFormatter
            .find('.shade-picker__shadename-toggle')
            .once()
            .click(function () {
              thisFormatter.find('.product__wrapper').toggleClass('hide-shadenames');

              return false;
            });
        }

        // preview/edit link toggle
        if (!thisFormatter.hasClass('is-mobile')) {
          thisFormatter
            .find('.product__footer__preview-toggle')
            .once()
            .click(function () {
              thisFormatter.find('.shade-picker__colors-overlay').toggleClass('hidden');
              thisFormatter.find('.product__wrapper').toggleClass('preview-palette');

              return false;
            });
        }

        $(window)
          .resize(
            _.debounce(function () {
              self.setShadesHeight(thisFormatter);
            }, 100)
          )
          .resize();

        // animate shade-picker__wrapper on close banner
        var $siteBanner = $('.site-banner:not(".hidden")');

        $(window).on('sidewideBanner:up:animationComplete', function () {
          if (!thisFormatter.hasClass('is-mobile')) {
            if (!$('.shade-picker__wrapper').hasClass('at-bottom')) {
              $('.shade-picker__wrapper').animate({ top: $siteBanner.height() + 'px' });
            }
          } else {
            var shadePickerColors = $('.shade-picker__colors');
            var siteBannerHeight = $siteBanner.height();

            shadePickerColors.animate({
              height: shadePickerColors.height() + siteBannerHeight,
              maxHeight: parseInt(shadePickerColors.css('max-height')) + siteBannerHeight + 'px'
            });
            shadePickerColors.attr('data-height', shadePickerColors.attr('data-height') + siteBannerHeight);
            shadePickerColors.attr('data-max-height', shadePickerColors.attr('data-max-height') + siteBannerHeight);
          }
        });

        // build existing custom palette
        self.getCustomPaletteArgs(thisFormatter);

        // remove category subnav
        thisFormatter.siblings('.sec-nav').find('.sec-nav__item').first().find('.sec-nav__sub-nav').remove();

        // toggle active insert
        $inserts.click(function () {
          if (!$(this).hasClass('active')) {
            var insert = $(this).data('insert');

            thisFormatter.attr('data-insert', insert);

            // toggle palette regions
            $inserts.removeClass('active');
            $(this).addClass('active');

            // toggle shade picker filters
            if (insert == filter_insert) {
              $shadePickerTools.removeClass('hidden');
            } else {
              $shadePickerTools.addClass('hidden');
            }

            if (thisFormatter.hasClass('is-mobile')) {
              // mobile: swap active shade list
              var $shadeListInserts = thisFormatter.find('.product__shade_list-insert');

              $shadeListInserts.removeClass('active');
              $('.product__shade_list-insert[data-insert="' + insert + '"]').addClass('active');
            } else {
              // swap shade picker heading
              shadePickerHeadings.addClass('hidden');
              $('.shade-picker__tools-heading[data-insert="' + insert + '"]').removeClass('hidden');

              // swap shade picker colors
              shadePickerInserts.addClass('hidden');
              $('.shade-picker__colors-insert[data-insert="' + insert + '"]').removeClass('hidden');
            }
          }
        });

        // initialize shade picker filters
        if (thisFormatter.data('insert') == filter_insert) {
          $shadePickerTools.removeClass('hidden');
        }
      });
    }
  };
})(jQuery, Drupal);
